import {
  GET_VOLCANO_LOCATIONS_REQUEST,
  CLEAR_VOLCANO_LOCATIONS,
  CLEAR_VOLCANO_LOCATION_REDIRECT,
  VOLCANO_LOCATION_SEARCH_COUNTRY_REQUEST,
  VOLCANO_LOCATION_SEARCH_REGION_REQUEST,
  VOLCANO_LOCATION_SEARCH_MORPHOLOGY_REQUEST,
  VOLCANO_LOCATION_SEARCH_STATUS_REQUEST,
  VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_REQUEST,
} from './volcanoLocationSearchReducer';

export const getVolcanoLocations = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: GET_VOLCANO_LOCATIONS_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});
export const clearVolcanoLocations = () => ({ type: CLEAR_VOLCANO_LOCATIONS });
export const clearVolcanoLocationRedirect = () => ({ type: CLEAR_VOLCANO_LOCATION_REDIRECT });
export const getCountries = ({ history }) => ({ type: VOLCANO_LOCATION_SEARCH_COUNTRY_REQUEST, history });
export const getRegions = ({ history }) => ({ type: VOLCANO_LOCATION_SEARCH_REGION_REQUEST, history });
export const getMorphologies = ({ history }) => ({ type: VOLCANO_LOCATION_SEARCH_MORPHOLOGY_REQUEST, history });
export const getStatuses = ({ history }) => ({ type: VOLCANO_LOCATION_SEARCH_STATUS_REQUEST, history });
export const getEruptionTimes = ({ history }) => ({ type: VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_REQUEST, history });
